module.exports = {
	title: 'Nav Box',
	notes: `
		https://www.w3.org/TR/wai-aria-practices/#accordion
		https://www.w3.org/TR/wai-aria-practices/#checkbox
	`,
	context: {
		title: 'Våra verksamhetsområden',
		toggle: 'Välj område',
		items: [
			'Armémateriel',
			'Logistikmateriel',
			'Marinmateriel',
			'Test & Evaluering',
			'Flygmateriel',
			'Gripen',
			'Ledningsmateriel',
			'Marknad & Inköp'
		]
	}
};